/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */

import { format, isValid, parseISO } from 'date-fns';

/* eslint-disable radix */
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const fullMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const getFormattedDate = (data, format = 'dd-mm-yyyy', monthInAlphabets = false) => {
    if (!data) return '';
    let newDate = data?.indexOf('T') > 0 ? data.split('T') : null;
    newDate = newDate[0];
    if (!(format === 'yyyy-mm-dd')) {
        try {
            newDate = new Date(newDate); // data
            const dateData = {};
            dateData.yyyy = newDate.getUTCFullYear();
            if (monthInAlphabets) {
                dateData.mm = monthNames[newDate.getUTCMonth()];
            } else dateData.mm = newDate.getUTCMonth() + 1 < 10 ? parseInt(`0${newDate.getUTCMonth() + 1}`, 10) : newDate.getUTCMonth() + 1;
            dateData.dd = newDate.getUTCDate() < 10 ? parseInt(`0${newDate.getUTCDate()}`, 10) : newDate.getUTCDate();
            const formatArr = format.split('-');
            if (formatArr.length > 0) {
                newDate = '';
                formatArr.forEach((item, index) => {
                    newDate += `${dateData[item]}`;
                    if (index < formatArr.length - 1) newDate += '-';
                });
            }
        } catch (e) {
            return data;
        }
    }
    return newDate;
};

export const convertDateToStr = (dateStr) => {
    // Split the input string into year, month, and day components
    const components = dateStr.split('-');
    const year = components[0];
    const month = components[1];
    const day = components[2];

    // Convert the month component to the corresponding abbreviation
    const monthAbbreviation = monthNames[parseInt(month) - 1];

    // Format the components into "dd-mmm-yy" format
    const convertedDate = `${day}-${monthAbbreviation}-${year}`;

    return convertedDate;
};

export const getDateTimeFields = (date) => {
    date = new Date(date);

    let hours = date.getUTCHours();
    hours %= 12;
    hours = hours || 12; // the hour '0' should be '12'

    let minutes = date.getUTCMinutes();

    minutes = minutes > 9 ? minutes : `0${minutes}`;
    return {
        hours,
        hours24: date.getUTCHours(),
        minutes
    };
};

export const handleDateFormat = (date, monthInAlphabets = false, separatedBySpace = false) => {
    if (!date) return;

    const dateArr = date.split('-');

    const year = dateArr[0];
    let month = dateArr[1];
    const day = dateArr[2];

    if (monthInAlphabets) {
        const monthNumber = Number(month);
        month = monthNames[monthNumber - 1];
    }

    if (separatedBySpace) {
        return `${day} ${month} ${year}`;
    }

    return [day, month, year].join('-');
};

export const getLocalDateTimeFields = (date) => {
    date = new Date(date);

    let hours = date.getHours();
    hours %= 12;
    hours = hours || 12; // the hour '0' should be '12'

    let minutes = date.getMinutes();

    minutes = minutes > 9 ? minutes : `0${minutes}`;
    return {
        hours,
        hours24: date.getHours(),
        minutes
    };
};

export const getDateAMPM = (date) => {
    const dateobj = new Date(date);
    let time = dateobj.toLocaleTimeString();
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
        time.splice(3, 1);
    }
    return time.join(''); // return adjusted time or original string
};

export const getFormattedDateAMPM = (dateString) => {
    const date = new Date(dateString);

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    return {
        hours,
        minutes
    };
};

export const getOffsetDateAMPM = (timestamp) => {
    if (!timestamp) return '';
    let time = timestamp.split('T');
    time = time.length > 1 ? time[1] : null;
    if (!time) return '';
    time = time.split(':');
    let h = time[0] ? time[0] : '';
    const m = time[1] ? time[1] : '';
    const amOrPm = h < 12 ? 'AM' : 'PM';
    h = +h % 12 || 12;
    return `${h}:${m} ${amOrPm}`;
};

export const getMonthsInDateInterval = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const startYear = start.getFullYear();
    const startMonth = start.getMonth();
    const endYear = end.getFullYear();
    const endMonth = end.getMonth();

    const monthsBetween = [];
    let currentMonth = startMonth;
    let currentYear = startYear;

    while (currentYear < endYear || (currentYear === endYear && currentMonth <= endMonth)) {
        const monthName = new Date(currentYear, currentMonth).toLocaleString('default', { month: 'short' });
        const year = currentYear.toString().substr(-2);
        const formattedName = `${monthName} ${year}`;
        monthsBetween.push(formattedName);

        currentMonth++;
        if (currentMonth > 11) {
            currentMonth = 0;
            currentYear++;
        }
    }

    return monthsBetween;
};

export const getDateAndMonth = (timestamp = '', appendYear = false, shareFormat = false) => {
    if (!timestamp) return;
    let time = timestamp.split('T')[0];
    time = time.split('-');
    const day = time.length > 2 ? time[2] : null;
    let month = time.length > 2 ? time[1] : null;
    const year = time.length > 2 ? time[0] : null;
    if (month) month = monthNames[Number(month) - 1];
    if (shareFormat) return `${day || ''}-${month || ''}-${year || ''}`;
    if (appendYear) return `${day || ''} ${month || ''} ${year || ''}`;
    return `${day || ''} ${month || ''}`;
};

export const getTime = (timestamp = '') => {
    if (!timestamp) return '';
    let time = timestamp.split('T');
    time = time.length > 1 ? time[1] : null;
    if (!time) return '';
    time = time.split(':');
    const h = time[0] ? time[0] : '';
    const m = time[1] ? time[1] : '';
    return `${h}:${m}`;
};

export const getHrsTimeSlot = (date) => {
    const hours = new Date(date).getHours();
    let slot = null;
    if (hours >= 0 && hours < 8) slot = 1;
    else if (hours >= 8 && hours < 12) slot = 2;
    else if (hours >= 12 && hours < 16) slot = 3;
    else if (hours >= 16 && hours < 20) slot = 4;
    else if (hours >= 20 && hours < 24) slot = 5;
    return slot;
};

export const timeConvert = (duration = null) => {
    if (!duration) return;
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    let flightDuration = null;
    if (hours) flightDuration = `${hours}h ${minutes}m`;
    else flightDuration = `${minutes}m`;
    return flightDuration;
};

export const convertTimestamp = (timestamp, dateFormat = 'dd MMM yyyy, h:mm a') => {
    // Check if the timestamp is null, undefined, or invalid
    if (!timestamp) {
        return ''; // Return dash if the timestamp is invalid
    }

    // Parse the ISO timestamp
    const date = parseISO(timestamp);

    // Check if the date is valid
    if (!isValid(date)) {
        return ''; // Return dash if the date is not valid
    }

    // Format the valid date
    return format(date, dateFormat);
};
